module.exports = __webpack_public_path__ + "fonts/CiscoSansTTLightOblique.woff2";